<template>
  <div class="quote-followup mt-4">
    <div class="section-header d-flex align-items-center mb-3">
      <h6 class="font-semi-bold m-0">Seguimiento automático</h6>
    </div>

    <!-- Toggle: Activar seguimiento -->
    <b-row class="mb-3">
      <b-col xs="12" md="6">
        <el-switch
          v-model="localEnableFollowup"
          active-text="Activar seguimiento automático"
          inactive-text="Sin seguimiento"
          active-color="#0e0051"
          @change="onToggle"
        />
        <small class="text-muted d-block mt-1" v-if="!localEnableFollowup">
          El sistema enviará recordatorios automáticos si el cliente no responde
          a la cotización.
        </small>
      </b-col>
    </b-row>

    <!-- Selección de secuencia -->
    <div v-if="localEnableFollowup">
      <b-row class="mb-2">
        <b-col xs="12" md="6">
          <label class="font-semi-bold d-block mb-1">
            Frecuencia de seguimiento
          </label>
          <select
            class="form-control"
            v-model="localSequenceId"
            @change="onSequenceChange"
          >
            <option :value="null" disabled>Seleccionar...</option>
            <option v-for="seq in quoteSequences" :key="seq.id" :value="seq.id">
              {{ seq.name }}
              ({{ seq.steps ? seq.steps.length : 0 }} envíos)
            </option>
          </select>
        </b-col>
      </b-row>
      <!-- Preview -->
      <b-row v-if="selectedSequence" class="mb-3">
        <b-col xs="12" md="8">
          <div class="sequence-preview">
            <small class="font-semi-bold d-block mb-1">
              Envíos programados si no hay respuesta:
            </small>
            <div
              v-for="(step, idx) in selectedSequence.steps"
              :key="idx"
              class="step-preview"
            >
              <i class="el-icon-message"></i>
              <span>{{ stepDescription(step) }}</span>
            </div>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import reminderService from "../../../../reminders/services/ReminderService";

export default {
  name: "QuoteFollowupComponent",
  props: {
    enableFollowup: { type: Boolean, default: false },
    reminderSequenceId: { type: Number, default: null }
  },
  data() {
    return {
      sequences: [],
      localEnableFollowup: this.enableFollowup,
      localSequenceId: this.reminderSequenceId
    };
  },
  computed: {
    quoteSequences() {
      return this.sequences.filter(s => s.type === "quote");
    },
    selectedSequence() {
      if (!this.localSequenceId) return null;
      return this.sequences.find(s => s.id === this.localSequenceId);
    }
  },
  methods: {
    async loadSequences() {
      try {
        const res = await reminderService.getSequences();
        if (res.data && res.data.data) {
          this.sequences = res.data.data;
          // Auto-seleccionar y activar la secuencia por defecto
          if (!this.localSequenceId) {
            const def = this.quoteSequences.find(s => s.is_default);
            if (def) {
              this.localSequenceId = def.id;
              if (this.localEnableFollowup) {
                this.emit();
              }
            }
          }
        }
      } catch (e) {
        this.sequences = [];
      }
    },

    stepDescription(step) {
      const labels = {
        before_due: "antes de que expire",
        after_due: "después de que expire",
        after_creation: "después de enviar la cotización"
      };
      return step.trigger_days + " días " + (labels[step.trigger_type] || "");
    },

    onToggle(val) {
      if (!val) this.localSequenceId = null;
      this.emit();
    },

    onSequenceChange() {
      this.emit();
    },

    emit() {
      this.$emit("onChange", {
        enableFollowup: this.localEnableFollowup,
        reminderSequenceId: this.localEnableFollowup
          ? this.localSequenceId
          : null
      });
    }
  },
  mounted() {
    this.loadSequences();
  }
};
</script>

<style scoped>
.quote-followup {
  border-top: 1px solid #eee;
  padding-top: 1.5rem;
}
.section-header h6 {
  color: #0e0051;
}
.sequence-preview {
  background: #f0f7ff;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 13px;
}
.step-preview {
  padding: 3px 0;
  color: #555;
}
.step-preview i {
  color: #0e0051;
  margin-right: 6px;
}
</style>
